import React from 'react';
import {CommonCreate, FILE} from '../Common';
import {getInputs} from './Common';
import {useNotify} from 'react-admin';
import {required} from 'react-admin';

export const DocumentCreate = props => {
  const notify = useNotify();

  const handleFailure = error => {
    // Afficher le message d'erreur dans la notification
    notify(
      typeof error === 'string' ? error : error.message || 'Une erreur est survenue',
      {type: 'warning'}
    );
  };

  return (
    <CommonCreate
      {...{
        ...props,
        onFailure: handleFailure,
        fields: [
          {
            label: 'Search document (Max. 10Mo)',
            source: 'file',
            type: FILE,
            maxSize: 10000000,
            multiple: false,
            accept:
              'application/pdf, application/x-pdf, image/jpeg, image/png, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            validate: [required('The document is mandatory')],
          },
          ...getInputs(),
        ],
      }}
    />
  );
};
